// Mean Earth radius (IUGG). Surface great-circle distance, not a road route.
export function straightDistanceKm(lon:number,lat:number,toLon:number,toLat:number):number {
 const rad=Math.PI/180,dLat=(toLat-lat)*rad,dLon=(toLon-lon)*rad;
 const a=Math.sin(dLat/2)**2+Math.cos(lat*rad)*Math.cos(toLat*rad)*Math.sin(dLon/2)**2;
 return 6371.0088*2*Math.asin(Math.sqrt(Math.min(1,Math.max(0,a))));
}
export function distanceLabel(km:number):string {return km<1?`${Math.round(km*1000)} m`:`${km.toFixed(1)} km`}
